import LoadTick from "./LoadTick";

export default LoadTick;
